export { SURFACE, TEXT, BORDER, TRADING, SEMANTIC, PRIMARY as TOKEN_PRIMARY, RADIUS, FONT, FONT_SIZE, BREAKPOINTS } from './design-tokens';

import colors from 'tailwindcss/colors';

export const COLORS = {
  primary: {
    50: '#E7EAFD',
    100: '#D5D9FB',
    200: '#AAB2F8',
    300: '#808CF4',
    400: '#5665F1',
    500: '#293DED',
    600: '#1124CF',
    700: '#0D1B9B',
    800: '#091268',
    900: '#040934',
    950: '#020418'
  },
  secondary: colors.violet,
  error: colors.red,
  warning: colors.orange,
  info: colors.cyan,
  success: colors.green,
  grey: colors.neutral,
  background: '#000000'
} as const;

export const EXTRA_COLORS = {
  white: colors.white,
  black: colors.black,
  current: colors.current,
  inherit: colors.inherit,
  transparent: colors.transparent,
  slate: colors.slate,
  'blue-grey': colors.gray,
  zinc: colors.zinc,
  neutral: colors.neutral,
  stone: colors.stone,
  red: colors.red,
  orange: colors.orange,
  amber: colors.amber,
  yellow: colors.yellow,
  lime: colors.lime,
  green: colors.green,
  emerald: colors.emerald,
  teal: colors.teal,
  cyan: colors.cyan,
  sky: colors.sky,
  blue: {
    50: '#F2F9FF',
    100: '#E6F3FF',
    200: '#BFE1FF',
    300: '#99CEFF',
    400: '#4DAAFF',
    500: '#0085FF',
    600: '#0078E6',
    700: '#005099',
    800: '#003C73',
    900: '#00284D'
  },
  indigo: colors.indigo,
  violet: colors.violet,
  purple: colors.purple,
  fuchsia: colors.fuchsia,
  pink: colors.pink,
  rose: colors.rose
} as const;

export const mainFont = 'Gabarito, sans-serif';
